<form #container class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">
  <fieldset class="k-form-fieldset">

    <!-- Codigo -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="codigo" [text]="customMsgService.translate('codigo')"> </kendo-label>
      <kendo-textbox formControlName="codigo" [clearButton]="true" #codigo required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('codigo') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>


    <!-- TRadução em PT -->
    <kendo-formfield orientation="horizontal">
      <kendo-label class="k-label" [for]="pt" [text]="customMsgService.translate('pt')"> </kendo-label>
      <kendo-textbox formControlName="pt" (inputBlur)="inputBlur()" [clearButton]="true" #pt required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('pt') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <!-- TRadução em EN -->
    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="en" [text]="customMsgService.translate('en')"> </kendo-label>
      <kendo-textbox formControlName="en" [clearButton]="true" #en required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('en') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>
    </kendo-formfield>

    <!-- TRadução em ES -->
    <kendo-formfield orientation="horizontal">
      <kendo-label [for]="fr" [text]="customMsgService.translate('fr')"> </kendo-label>
      <kendo-textbox formControlName="fr" [clearButton]="true" #fr required> </kendo-textbox>
      <kendo-formerror> {{ customMsgService.translate('error') }}: {{ customMsgService.translate('theField') }} {{
        customMsgService.translate('fr') }} {{ customMsgService.translate('isRequired') }}</kendo-formerror>

    </kendo-formfield>


    <kendo-dialog-actions>
      <button kendoButton (click)="onCancelAction()">
        {{ customMsgService.translate('cancel') }}
      </button>
      <button kendoButton (click)="saveChanges()" themeColor="primary" [disabled]="!formGroup.valid">
        {{ customMsgService.translate('saveChanges') }}
      </button>
    </kendo-dialog-actions>


  </fieldset>
</form>